import { Toast } from '../components/toast'
import toast from 'react-hot-toast'

type ToastFunction = (title: string, message: string) => void

interface ToastHelper {
  success: ToastFunction
  error: ToastFunction
  dismissibleError: ToastFunction
}

const toastHelper: ToastHelper = {
  success: (title: string, message: string) => {
    toast.success(
      <Toast
        variant="success"
        title={title}
        message={message}
      />,
      {
        duration: 5000,
      },
    )
  },
  error: (title: string, message: string) => {
    toast.error(
      <Toast
        variant="error"
        title={title}
        message={message}
      />,
      {
        duration: 5000,
      },
    )
  },
  dismissibleError: (title: string, message: string) => {
    toast.error(
      <Toast
        variant="error"
        title={title}
        message={message}
        showCloseButton={true}
      />,
      {
        duration: Infinity,
      },
    )
  },
}

export default toastHelper
